import type { AbsenceRecord, AbsenceTypeRecord } from '@/libs/interfaces'

import { MOCK_ORG_ID, MOCK_STORE_ID_1, MOCK_STORE_ID_2 } from './seed'

/**
 * Absence type catalogue + absence records cross-referencing seed.ts
 * employees and stores.
 */

export const MOCK_ABSENCE_TYPE_ID_VACATION = 'absence-type-vacation'
export const MOCK_ABSENCE_TYPE_ID_SICK = 'absence-type-sick'
export const MOCK_ABSENCE_TYPE_ID_PARENTAL = 'absence-type-parental'
export const MOCK_ABSENCE_TYPE_ID_UNPAID = 'absence-type-unpaid'

export const mockAbsenceTypes: AbsenceTypeRecord[] = [
  {
    absenceTypeID: MOCK_ABSENCE_TYPE_ID_VACATION,
    orgID: MOCK_ORG_ID,
    name: 'Vacation',
    code: 'VAC',
    description: 'Paid annual vacation leave',
    requiresApproval: true,
    advanceNoticeDays: 14,
    requiresDocumentation: false,
    isPaid: true,
    annualLimitDays: 25,
    allowPartialDay: false,
    colorCode: '#22c55e',
    absenceTypeStatus: 'Active',
    createdAt: '2025-01-01T08:00:00Z',
    updatedAt: '2025-01-01T08:00:00Z',
  },
  {
    absenceTypeID: MOCK_ABSENCE_TYPE_ID_SICK,
    orgID: MOCK_ORG_ID,
    name: 'Sick Leave',
    code: 'SICK',
    description: 'Paid sick leave',
    requiresApproval: false,
    advanceNoticeDays: 0,
    requiresDocumentation: true,
    isPaid: true,
    annualLimitDays: 30,
    allowPartialDay: true,
    colorCode: '#ef4444',
    absenceTypeStatus: 'Active',
    createdAt: '2025-01-01T08:00:00Z',
    updatedAt: '2025-01-01T08:00:00Z',
  },
  {
    absenceTypeID: MOCK_ABSENCE_TYPE_ID_PARENTAL,
    orgID: MOCK_ORG_ID,
    name: 'Parental Leave',
    code: 'PAR',
    description: 'Parental leave per Swedish social insurance',
    requiresApproval: true,
    advanceNoticeDays: 60,
    requiresDocumentation: true,
    isPaid: true,
    allowPartialDay: true,
    colorCode: '#3b82f6',
    absenceTypeStatus: 'Active',
    createdAt: '2025-01-01T08:00:00Z',
    updatedAt: '2025-01-01T08:00:00Z',
  },
  {
    absenceTypeID: MOCK_ABSENCE_TYPE_ID_UNPAID,
    orgID: MOCK_ORG_ID,
    name: 'Unpaid Leave',
    code: 'UNPAID',
    description: 'Unpaid leave of absence',
    requiresApproval: true,
    advanceNoticeDays: 7,
    requiresDocumentation: false,
    isPaid: false,
    allowPartialDay: true,
    colorCode: '#94a3b8',
    absenceTypeStatus: 'Active',
    createdAt: '2025-01-01T08:00:00Z',
    updatedAt: '2025-01-01T08:00:00Z',
  },
]

export const mockAbsences: AbsenceRecord[] = [
  {
    absenceID: 'absence-1',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_1,
    employeeID: 'employee-2',
    absenceTypeID: MOCK_ABSENCE_TYPE_ID_VACATION,
    startDateTime: '2025-07-07T00:00:00Z',
    endDateTime: '2025-07-11T23:59:00Z',
    durationMinutes: 2400,
    reason: 'Summer vacation',
    status: 'Active',
    approvedById: 'employee-1',
    approvedAt: '2025-06-20T10:00:00Z',
    createdAt: '2025-06-15T08:00:00Z',
    updatedAt: '2025-06-20T10:00:00Z',
  },
  {
    absenceID: 'absence-2',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_1,
    employeeID: 'employee-3',
    absenceTypeID: MOCK_ABSENCE_TYPE_ID_SICK,
    startDateTime: '2025-06-23T00:00:00Z',
    endDateTime: '2025-06-24T23:59:00Z',
    durationMinutes: 960,
    reason: 'Flu',
    status: 'Active',
    createdAt: '2025-06-23T07:00:00Z',
    updatedAt: '2025-06-23T07:00:00Z',
  },
  {
    absenceID: 'absence-3',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_2,
    employeeID: 'employee-6',
    absenceTypeID: MOCK_ABSENCE_TYPE_ID_PARENTAL,
    startDateTime: '2025-05-01T00:00:00Z',
    endDateTime: '2025-08-31T23:59:00Z',
    durationMinutes: 176160,
    reason: 'Parental leave',
    status: 'Active',
    approvedById: 'employee-1',
    approvedAt: '2025-04-10T09:00:00Z',
    createdAt: '2025-04-01T08:00:00Z',
    updatedAt: '2025-04-10T09:00:00Z',
  },
  {
    absenceID: 'absence-4',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_2,
    employeeID: 'employee-5',
    absenceTypeID: MOCK_ABSENCE_TYPE_ID_UNPAID,
    startDateTime: '2025-07-21T00:00:00Z',
    endDateTime: '2025-07-21T23:59:00Z',
    durationMinutes: 480,
    reason: 'Personal matter',
    status: 'Draft',
    createdAt: '2025-06-25T08:00:00Z',
    updatedAt: '2025-06-25T08:00:00Z',
  },
]
